import { ImageSource } from 'expo-image';

import BonanzaBoxLocked from './bonanza-box-locked.webp';
import Cash from './cash.webp';
import Coin from './coin.webp';
import Wheel from './wheel.webp';
import Spins from './freespins.webp';
import GiftBox from './giftbox.webp';
import Jackpot from './jackpot.webp';
import LevelUp from './levelup.webp';
import Megaphone from './megaphone.webp';
import BonanzaCoinStack from './bonanza-coin-stack.webp';
import BonanzaCoinsBank from './bonanza-coins-bank.webp';
import BonanzaPiggy from './bonanza-piggy.webp';
import BonanzaScratchcard from './bonanza-scratchcard.webp';
import BonanzaWheel from './bonanza-wheel.webp';
import GreenCheck from './green-check.webp';
import error from './error.webp';
import pending from './pending.webp';
import rejected from './rejected.webp';
import success from './success.webp';
import LimitReachedClock from './limit-reached-clock.webp';
import TimerClock from './clock.webp';
import Hourglass from './hourglass.webp';
import Clock from './clock-blue-red.webp';
import FallingCoins from './bonanza-coin-falling.webp';
import BonanzaNotification from './bonanza-notification.webp';
import Interac from './interac.webp';
import BonanzaBadge from './bonanza-badge.webp';
import check from './check.webp';
import Documents from './documents.webp';
import RotatingCoin from './rotating-coin.webp';
import homePageBackground from './home-page-background.webp';
import NotificationBell from './notification-bell.webp';
import plus from './plus.webp';
import clockV2 from './clockV2.webp';
import Lock from './lock.webp';
import UnlockedLock from './lock-unlocked.webp';
import DarkClock from './clock-dark.webp';
import chainsLocked from './chains-locked.webp';
import plusLight from './plus-light.webp';
import geoFence from './geoFence.webp';

import { registerImages } from './registry';

const images = {
  BonanzaBoxLocked,
  Cash,
  Coin,
  Wheel,
  Spins,
  GiftBox,
  Jackpot,
  LevelUp,
  Megaphone,
  BonanzaCoinStack,
  BonanzaCoinsBank,
  BonanzaPiggy,
  BonanzaWheel,
  BonanzaScratchcard,
  GreenCheck,
  error,
  pending,
  rejected,
  success,
  LimitReachedClock,
  TimerClock,
  Hourglass,
  Clock,
  FallingCoins,
  BonanzaNotification,
  Interac,
  BonanzaBadge,
  check,
  Documents,
  RotatingCoin,
  homePageBackground,
  NotificationBell,
  plus,
  clockV2,
  Lock,
  UnlockedLock,
  DarkClock,
  chainsLocked,
  plusLight,
  geoFence,
};

declare global {
  interface RegisteredImages {
    common: Record<keyof typeof images, ImageSource>;
  }
}

registerImages('common', images);

export { getImages } from './registry';
